export default __webpack_public_path__ + "static/media/yellow-ship.0b5ab4a0.png";